import { render, staticRenderFns } from "./CourseFloatingCard.vue?vue&type=template&id=4f114d95&scoped=true"
import script from "./CourseFloatingCard.vue?vue&type=script&lang=js"
export * from "./CourseFloatingCard.vue?vue&type=script&lang=js"
import style0 from "./CourseFloatingCard.vue?vue&type=style&index=0&id=4f114d95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f114d95",
  null
  
)

export default component.exports